import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import VoxelIconButton from '../Buttons/VoxelIconButton';

export interface VoxelDialogSidePanelProps {
  closeDisabled?: boolean;
  handleClose: () => void;
}

export const VoxelDialogSidePanel: React.FC<VoxelDialogSidePanelProps> = ({
  closeDisabled,
  handleClose,
  children,
}) => {
  return (
    <div
      className={`
      relative bg-white rounded-xl shadow p-8 
      w-fit h-full
      `}
    >
      <div className="absolute top-3 right-3">
        <VoxelIconButton
          size="lg"
          color="white"
          icon={<FontAwesomeIcon title={'Close'} icon={faXmark} size="xl" />}
          onClick={() => handleClose()}
          disabled={closeDisabled}
          type="button"
        />
      </div>
      {children}
    </div>
  );
};

export default VoxelDialogSidePanel;
